import React from 'react';
import { Outlet } from 'react-router-dom';

const DataProtection: React.FC = () => {
  return <Outlet />;
};

export default DataProtection;
